import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input, Select} from 'Components/Form';
import {Link, MailLink} from 'Components/Utilities';

import Auth from 'Services/Api/Auth/Auth';
import GroupsApi from 'Services/Api/Groups/Groups';

import {translation} from 'Services/TranslationHelpers';

class Login extends React.Component {
    /**
     * @var state
     */
    state = {
        adminLogin: false,
        groupName: null
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {adminLogin, groupName} = this.state;
        const {form, handleInput, getFieldError, handleSubmit, working, alert} = this.props;

        // Set the column that the user will login with. Email if admin else set by config.
        let login_column = adminLogin ? 'email' : window.base.login_column;

        // Do not display the group selector by default.
        let display_group_selector = true;

        // If the login_column config is an array then it indicates that it depends on the user-group
        // so display the group-selector and set the login_column according to the selected group.
        if (typeof login_column === 'object') {
            display_group_selector = true;
            login_column = groupName ? login_column[groupName] : null;
        }

        return (
            <Unauthenticated>
                <AuthLayout
                    backLink={window.base.features.allow_password_resets && login_column ? "/password/request" : null}
                    backLinkText={translation('auth_frontend', 'forgot_your_password')}
                    submitText={login_column  ? translation('auth_frontend', 'login') : null}
                    onSubmit={(e) => handleSubmit(e, Auth.login)}
                    working={working}
                    alert={alert}
                >
{/*                    <p className="text-white mb-8 font-bold">
                        Registration is now closed
                    </p>

                    <p className="text-white mb-8">
                        If you experience any issues logging in please contact <MailLink/>
                    </p>*/}
                    {!groupName &&
                        <div className="w-full lg:w-full boots-sharp text-2xl text-black space-y-5">
                            <div className="font-bold text-6xl">
                                Welcome
                            </div>

                            {/*<div className="font-bold">
                                Thanks very much for stopping by.
                            </div>*/}

                            {/*<div className="font-bold">
                                Need to Register?
                            </div>*/}

                            {/*<div className="font-light">
                                 Before we can give you access to our fantastic virtual event platform,
                                we need to capture some information from you to get you signed up.
                                You will need the password sent to you in your invitation. Please select your role from the drop-down list.
                            </div>*/}

                            {/*<div className="font-bold">
                                Already Registered?
                            </div>

                            <div className="font-light">
                                 To view our fantastic virtual event platform,
                                please login using the information you used to register,
                                as well as the password you reset at registration. To reset your password,
                                select your job title and follow the Forgotten Password.
                            </div>*/}
                        </div>
                    }
                    {groupName &&
                        <div className="w-full lg:w-full boots-sharp text-2xl text-black space-y-5">
                            <div className="font-bold text-6xl">
                                Login
                            </div>

                            {/*<div className="font-bold">
                                Need to Register?
                            </div>*/}

                            {(groupName === 'Advisor' || groupName === 'Store Manager')  &&
                                <div className="font-light my-8">
                                    Please enter your details below and password
                                </div>
                            }

                            {groupName !== 'Advisor' && groupName !== 'Store Manager' &&
                                <div className="font-light my-8">
                                    Please enter your email address and password.
                                </div>
                            }

                            {/*<div className="font-bold">
                                Already Registered?
                            </div>

                            <div className="font-light">
                                Please enter the password you reset at registration.
                                If you need to reset your password hit Forgotten Password.
                            </div>*/}
                        </div>
                    }

                    {display_group_selector && !groupName &&
                        <div className={"flex flex-row mt-5"}>
                            <div className={"w-1/3 text-center m-auto text-xl"}>
                                Job role
                            </div>
                            <Select
                                containerClassName="my-4 w-2/3"
                                value={form.group_id}
                                error={getFieldError('group_id')}
                                onChange={(v) => {
                                    handleInput('group_id', v.id);
                                    this.setState({groupName: v.name});
                                }}
                                isAsync
                                searchCallback={(data) => GroupsApi.get(null, {
                                    ...data,
                                    hasNoTeam: true
                                })}
                                searchLabelKey="name"
                                allowNull={false}
                                returnObject={true}
                                labelTextColor="text-black"
                            />
                        </div>
                    }

                    {login_column &&
                        <div className={"w-3/4 mx-auto mt-5"}>
                            <Input
                                containerClassName="mb-4 flex flex-row"
                                label={translation('auth_frontend', login_column)}
                                type={login_column === "email" ? "email" : null}
                                value={form[login_column]}
                                error={getFieldError(login_column)}
                                onChange={v => handleInput(login_column, v)}
                                labelTextColor="text-black"
                            />

                            <Input
                                label={translation('auth_frontend', 'password')}
                                type="password"
                                value={form.password}
                                error={getFieldError('password')}
                                onChange={v => handleInput('password', v)}
                                labelTextColor="text-black"
                                containerClassName="flex flex-row text-center"

                            />
                        </div>
                    }
                    {window.base.login_column !== 'email' &&
                        <p
                            className="text-sm text-black cursor-pointer text-right mt-4"
                            onClick={() => this.setState({adminLogin: !adminLogin})}
                        >
                            {adminLogin ?
                                'Return To Login' :
                                'Admin Login'}
                        </p>
                    }

                </AuthLayout>

                <div className="font-light">
                    If you have any issues or questions please contact
                    {" " }
                    <MailLink />
                </div>

                {window.base.features.allow_registrations &&
                    <p className="text-center text-black mt-4">
                        <Link to="/register">
                            {translation('auth_frontend', 'register_here')}
                        </Link>
                    </p>
                }
            </Unauthenticated>
        );
    }
}

export default FormHandler(Login);
